import { useCallback, useState } from "react";

import API from "@/api";
import { useQueryClient } from "@tanstack/react-query";
import useTanks from "./useTanks";
import { ITank } from "@/types/data";

function useValidateTank(nurseryId: string) {
  const queryClient = useQueryClient();

  const { data: tanks } = useTanks(nurseryId);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [error, setError] = useState<Error>();
  const [success, setSuccess] = useState<boolean>(false);

  const validateTank = useCallback((nurseryId: string, tankId: string): Promise<ITank | void> => {
    setIsPending(true);
    setError(undefined);

    let tankSearchId = tankId;
    if (tankId.startsWith("https://mobile.seafoundry.com/tanks/")) {
      const uuid = tankId.split("tanks/")[1];
      const tank = tanks?.results.find(({ seafoundry_uuid }) => seafoundry_uuid === uuid);
      if (tank) {
        tankSearchId = tank.id.toString();
      } else {
        setError(new Error("Tank does not exist in nursery"));
        return Promise.resolve();
      }
    }

    return API.getTank(nurseryId, tankSearchId)
      .then(async (response) => {
        queryClient.setQueriesData(
          { queryKey: ["tanks", nurseryId, tankSearchId] },
          () => response
        );
        setSuccess(true);
        return Promise.resolve(response);
      })
      .catch(() => setError(new Error("Tank does not exist in nursery")))
      .finally(() => setIsPending(false));
  }, [queryClient, tanks?.results]);

  return {
    validateTank,
    isPending,
    error,
    success
  };
}

export default useValidateTank;
